module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "generic.4763920d.jpg";